const state = {
    currentLanguage: localStorage.getItem('language') || 'zh-CN',
    languages: [
        { key: 'zh-CN', name: '中文', flag: '🇨🇳' },
        { key: 'en-US', name: 'English', flag: '🇺🇸' }
    ]
}

const mutations = {
    SET_LANGUAGE(state, language) {
        state.currentLanguage = language
        localStorage.setItem('language', language)
    }
}

const actions = {
    setLanguage({ commit }, language) {
        commit('SET_LANGUAGE', language)
    }
}

const getters = {
    currentLanguage: state => state.currentLanguage,
    languages: state => state.languages
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
